import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  hrLine: {
    border: '1px solid #E6E6E8',
  },
  //career
  profileCard: {
    marginTop: '10px',
    padding: '22px',
    boxShadow: 'none !important',
    borderRadius: '9px !important',
  },
  button: {
    width: '100%',
    marginTop: '20px !important',
    borderRadius: '6px !important',
    fontSize: '10.5px !important',
    backgroundColor: '#3061FF',
    boxShadow: 'none !important',
    color: '#373A45',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10.5px !important',
      marginTop: '5px !important',
    },
  },
  viewidbutton: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    backgroundColor: '#3061FF',
    marginTop: '10px !important',
    color: 'white !important',
    boxShadow: 'none !important',
    height: '4vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  carrierBox: {
    border: '0.75px solid #E6E6E8',
    borderRadius: '9px',
    padding: '18px',
    marginTop: 15,
  },
  postJobBtns: {
    width: '150px',
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
  },
  postJobBtnsMsg: {
    width: '180px',
    borderRadius: '20px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
      padding: '10px !important',
      width: '110px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px !important',
      padding: '8px !important',
      width: '100px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '10px !important',
      padding: '7px !important',
      width: '90px',
    },
  },
  preferBtns: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    marginTop: '10px !important',
    color: '#373A45 !important',
    height: '4vh',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  preferBtns1: {
    width: '100%',
    marginLeft: '0px !important',
    borderRadius: '6px !important',
    padding: '7px !important',
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45 !important',
  },
  iconBtns: {
    borderRadius: '8px !important',
    padding: '7px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
  },
  profileDesignation: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    textAlign: 'left',
    width: '100%',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11px !important',
    },
  },
  referenceTitle: {
    fontSize: '12px !important',
    fontWeight: '500 !important',
    color: '#373A45',
    textAlign: 'left',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '11px !important',
    },
  },

  //Academic Records
  academicRecordBox: {
    backgroundColor: '#F6F8FB',
    marginTop: '10px',
    borderRadius: '12px',
    padding: '10px',
  },
  //Events
  eventsCardbox: {
    border: '0.75px solid #E6E6E8',
    borderRadius: '9px !important',
    padding: '18px !important',
    marginTop: 20,
  },
  //MentorShip
  mentorShipCard: {
    backgroundColor: '#F6F8FB',
    borderRadius: '9px !important',
    padding: '9px !important',
  },
  //Fundraise
  campaingsCard: {
    border: '0.75px solid #E6E6E8',
    marginTop: 10,
    borderRadius: 10,
    padding: 15,
  },
  campaingsCard1: {
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '26vh',
    },
  },
  donation: {
    backgroundColor: '#F6F8FB',
    padding: 20,
    borderRadius: 12,
  },
  //Table container
  tableContainer: {
    border: '2px solid #E5E6EA',
    borderRadius: 10,
  },
  scrollableContent: {
    height: '12.5vh',
    overflowY: 'auto',
  },
  iconBox: {
    backgroundColor: '#E8EBF3',
    padding: '12px !important',
    borderRadius: '8px !important',
    cursor: 'pointer',
  },
  preferenceBox: {
    marginTop: '-20px',
    height: '19.5vh',
    [theme.breakpoints.up('xxl')]: {
      height: '22.5vh',
    },
    '@media (min-width: 1536px) and (max-width: 1636px)': {
      height: '21vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '30vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '7.5vh !important',
    },
  },
  myProfileAppliedData: {
    height: '20vh',
    [theme.breakpoints.up('xxl')]: {
      height: '27vh',
    },
  },
}));
